import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const Warning: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 30 28'>
      <path
        d='M29.6054 22.8406L17.7497 2.00838C17.2077 1.02604 16.1915 0.450195 15.006 0.450195C13.8204 0.450195 12.8381 1.02604 12.2622 2.00838L0.406482 22.8406C-0.135494 23.8229 -0.135494 25.0085 0.406482 25.9908C0.948458 26.9731 1.96466 27.549 3.11636 27.549H26.7939C27.9456 27.549 28.9618 26.9731 29.5038 25.9908C30.1474 25.0085 30.1474 23.8229 29.6054 22.8406ZM16.7335 22.6035H13.5833V19.8597H16.7335V22.6035ZM16.7335 18.2677H13.5833V10.409H16.7335V18.2677Z'
        fill={props.fill}
      />
    </SvgIcon>
  );
};
